import React from 'react'
import { Select } from '@/components/ui'
import { PAYROLL_CYCLE_OPTIONS } from '@/features/organization/constants/settingsOptions'
import {
  FieldGrid,
  FieldGroup,
  LabeledToggleRow,
  SettingsPane,
  ToggleList,
} from '../organization-ui'
import type { OrganizationSettingsFormProps } from '../settings/organizationSettingsForm.types'

export const PayrollPane: React.FC<OrganizationSettingsFormProps> = ({
  setValue,
  watch,
  disabled = false,
}) => (
  <SettingsPane
    title="Payroll"
    description="How often payroll runs, and the approvals required before a run is final."
  >
    <FieldGroup label="Cycle">
      <FieldGrid columns={2}>
        <Select
          label="Payroll cycle"
          options={PAYROLL_CYCLE_OPTIONS}
          value={watch('payrollSettings.payrollCycleType') ?? ''}
          disabled={disabled}
          onChange={(v) =>
            setValue('payrollSettings.payrollCycleType', v as 'monthly' | 'biweekly' | 'weekly', {
              shouldDirty: true,
            })
          }
          placeholder="Select cycle"
        />
      </FieldGrid>
    </FieldGroup>

    <FieldGroup label="Approvals">
      <ToggleList>
        <LabeledToggleRow
          label="Require approval before finalizing"
          description="A payroll run must be approved before it can be finalized."
          checked={watch('payrollSettings.requireApproval') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('payrollSettings.requireApproval', checked, { shouldDirty: true })
          }
        />
        <LabeledToggleRow
          label="Lock payroll after approval"
          description="Prevent edits to a run once approval completes."
          checked={watch('payrollSettings.lockAfterApproval') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('payrollSettings.lockAfterApproval', checked, { shouldDirty: true })
          }
        />
      </ToggleList>
    </FieldGroup>
  </SettingsPane>
)

PayrollPane.displayName = 'PayrollPane'
